// extracted by mini-css-extract-plugin
export default {"validationModal":"validationModal_validationModal__NZ8xL","subInfo":"validationModal_subInfo__2yl+s"};